import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { NavItem, Nav, NavDropdown } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import NavItemNoIcon from './NavItemNoIcon';
import NavBookmarksMenuItem from './NavBookmarksMenuItem';
import CaptureClicksV2 from '../../components/CaptureClicksV2';
import { ROUTE_PREFIXES, MENU_STATUS_OBJECT, SEGMENT_EVENTS } from '../../../shared/Constants';
import TeamsDropdown from './TeamsDropdown';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../shared/components/modals/ConfirmationModal';
import { withRouter } from 'react-router-dom';
import { setUnsavedChanges } from '../../../shared/actions';

class NavigationContentMenu extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // confirmationModal: false,
            confirmModalValue: null,
            // currentPath: ''
        }
    }

    static propTypes = {
        isVerbAdmin: PropTypes.bool,
        userCompany: PropTypes.object,
        loggedInUser: PropTypes.object,
        pathName: PropTypes.string,
        activeUserTeams: PropTypes.array,
        isContentAuthor: PropTypes.bool,
        isContentAdmin: PropTypes.bool,
        isVerbReportViewer: PropTypes.bool,
        isAccountOwner: PropTypes.bool,
        isInstructionalAdmin: PropTypes.bool,
        isInstructionalContentAdmin: PropTypes.bool,
        isInstructionalReportViewer: PropTypes.bool,
        isContentReviewer: PropTypes.bool,
        featureFlagData: PropTypes.object,
    };

    static contextType = RuntimeContext;

    // handleNavigation = (path, trackingEvent = null) => {
    //     const { teamsUnsavedFlag } = this.props;

    //     if (trackingEvent) {
    //         this.handleElementTracking(SEGMENT_EVENTS.NAV_DISCOVER)
    //     }

    //     const teamsRegex = /^\/admin\/editcompany\/[^\/]+\/teams(\/[^\/]+)?$/;
    //     const isCurrentPathsTeams = teamsRegex.test(this.props.location.pathname);

    //     if (isCurrentPathsTeams && teamsUnsavedFlag) {
    //         this.setState({
    //             confirmationModal: true,
    //             currentPath: path
    //         })
    //     } else {
    //         this.props.history.push(path);
    //     }

    // }

    _buildContentMenu = () => {
        const { userCompany = {}, loggedInUser, pathName, activeUserTeams = [], isVerbAdmin, isContentAuthor, isContentAdmin, isVerbReportViewer, isAccountOwner, isInstructionalAdmin, isInstructionalContentAdmin, isInstructionalReportViewer, isContentReviewer, featureFlagData } = this.props;
        const discoverPageActive = pathName === ROUTE_PREFIXES.DISCOVER;
        const homePageActive = pathName === ROUTE_PREFIXES.HOME;
        const groupPageActive = pathName.includes(ROUTE_PREFIXES.TEAMS);
        const bookmarksActive = pathName && pathName.includes(ROUTE_PREFIXES.PROFILE_BOOKMARK);
        const adminActive = pathName && pathName.includes(ROUTE_PREFIXES.ADMIN);
        const menuItems = [];

        if (!isEmpty(loggedInUser)) {
            menuItems.push(
                <NavItem
                    key={'home'}
                    className={cns('navbar-section', 'navbar-home', { selected: homePageActive })}
                    onClick={() => this.props.handleNavigation('/home', SEGMENT_EVENTS.NAV_DISCOVER)}
                >
                    <Nav.Link eventKey={1}>
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={homePageActive}
                                key={'skillsIcon'}
                                textId={'NAVIGATION_HOME'}
                                defaultMessage={'HOME'}
                            />
                        </CaptureClicksV2>
                    </Nav.Link>
                </NavItem>
            );

            menuItems.push(
                <NavItem
                    key={'discover'}
                    className={cns('navbar-section', 'navbar-discover', { selected: discoverPageActive })}
                    onClick={() => this.props.handleNavigation('/discover', SEGMENT_EVENTS.NAV_DISCOVER)}
                >
                    <Nav.Link eventKey={1}>
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={discoverPageActive}
                                key={'skillsIcon'}
                                textId={'NAVIGATION_DISCOVER'}
                                defaultMessage={'DISCOVER'}
                            />
                        </CaptureClicksV2>
                    </Nav.Link>
                </NavItem>
            );
        }

        if (!isEmpty(loggedInUser)) {
            menuItems.push(<NavBookmarksMenuItem bookmarksActive={bookmarksActive} loggedInUser={loggedInUser} handleNavigation={this.props.handleNavigation} />);
        }

        if (!isEmpty(loggedInUser)) {
            menuItems.push(
                <NavItem
                    key={'mobile-bookmarks-nav'}
                    className={cns('navbar-section', 'mobile-bookmarks-nav', { selected: homePageActive })}
                    onClick={() => this.props.handleNavigation(`/profile/'${loggedInUser._id}'/bookmarks`, SEGMENT_EVENTS.NAV_BOOKMARKS)}
                >
                    <Nav.Link eventKey={1}>
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={bookmarksActive}
                                key={'bookmarks-mobile'}
                                textId={'NAVIGATION_BOOKMARKS'}
                                defaultMessage={'BOOKMARKS'}
                            />
                        </CaptureClicksV2>
                    </Nav.Link>
                </NavItem>
            );
        }

        if (!isEmpty(loggedInUser) && loggedInUser.teams) {
            const teamsSortedByJoinedDate = activeUserTeams.sort((a, b) =>
                new Date(a.joinedDateTime) < new Date(b.joinedDateTime) ? 1 : -1
            );
            menuItems.push(
                <TeamsDropdown
                    loggedInUser={loggedInUser}
                    teamsSortedByJoinedDate={teamsSortedByJoinedDate}
                    groupPageActive={groupPageActive}
                    pathName={pathName}
                    teamsLabel={userCompany.teamsLabel}
                    handleNavigation={this.props.handleNavigation}
                />
            );
            menuItems.push(
                <NavItem
                    key={'mobile-groups-nav'}
                    className={cns('navbar-section', 'mobile-groups-nav', 'navbar-teams', { selected: homePageActive })}
                    onClick={() => this.props.handleNavigation('/grouplist', SEGMENT_EVENTS.NAV_TEAMS)}
                >
                    <Nav.Link eventKey={1}>
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={groupPageActive}
                                key={'groups-mobile'}
                                textId={'GROUP'}
                                defaultMessage={
                                    teamsSortedByJoinedDate.length === 1
                                        ? `${teamsSortedByJoinedDate[0].name?.toUpperCase()}`
                                        : userCompany?.teamsLabel?.toUpperCase() || 'GROUP'
                                }
                            />
                        </CaptureClicksV2>
                    </Nav.Link>
                </NavItem>
            );
        }

        if (!isEmpty(loggedInUser) && (isVerbAdmin ||
            isContentAuthor ||
            isContentAdmin ||
            isVerbReportViewer ||
            isAccountOwner ||
            isInstructionalAdmin ||
            isInstructionalContentAdmin ||
            isInstructionalReportViewer ||
            isContentReviewer)
        ) {
            menuItems.push(
                <NavItem
                    key={'admin'}
                    className={cns('navbar-section', 'navbar-admin', { selected: adminActive })}
                    id={'paths-admin-nav-button'}
                    onClick={() => this.props.handleNavigation(`/admin/editcompany/${userCompany._id}/${featureFlagData?.Paths_AdminResources ? 'adminResources' : 'teams'}`)}
                >
                    <Nav.Link eventKey={1}>
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={adminActive}
                                key={'skillsIcon'}
                                textId={'NAVIGATION_ADMIN'}
                                defaultMessage={'ADMIN'}
                            />
                        </CaptureClicksV2>
                    </Nav.Link>
                </NavItem>
            );
        }

        if (featureFlagData?.Paths_ShowContentTools && (isVerbAdmin || isContentAdmin)) {
            menuItems.push(
                <NavDropdown
                    key={'contentAdmin'}
                    className={cns('navbar-section', 'navbar-dropdown-default', 'navbar-content-admin', { selected: adminActive })}
                    id={'paths-content-admin-nav-button'}
                    title={
                        <CaptureClicksV2>
                            <NavItemNoIcon
                                isSelected={adminActive}
                                key={'contentAdminIcon'}
                                textId={'NAVIGATION_CONTENT_ADMIN'}
                                defaultMessage={'CONTENT'}
                            />
                        </CaptureClicksV2>
                    }
                >
                    <NavDropdown.Item
                        onClick={() => this.props.handleNavigation('/managelearningassets', SEGMENT_EVENTS.NAV_CONTENT)}
                    >
                        ACTIVITIES
                    </NavDropdown.Item>
                    <NavDropdown.Item
                        onClick={() => this.props.handleNavigation('/managecollections', SEGMENT_EVENTS.NAV_CONTENT)}
                    >
                        PATHS
                    </NavDropdown.Item>
                    <NavDropdown.Item
                        onClick={() => this.props.handleNavigation('/managecontentframework', SEGMENT_EVENTS.NAV_CONTENT)}
                    >
                        DIMENSIONS
                    </NavDropdown.Item>
                    <NavDropdown.Item
                        onClick={() => this.props.handleNavigation('/medialibrary', SEGMENT_EVENTS.NAV_CONTENT)}
                    >
                        MEDIA LIBRARY
                    </NavDropdown.Item>
                </NavDropdown>
            );
        }

        return menuItems;
    };

    render() {
        const { confirmationModal, confirmActionFunction, confirmCancelFunction } = this.props;
        const messageTextProp = {
          messageId: 'Confimation Modal for Unsaved Changes',
          defaultMessage: 'You have unsaved changes that will be discarded.',
        }

        const confimationTitle = 'Leave without saving?';

        const cancelButtonProp = {
            textId: 'Cancel btn',
            defaultMessage: 'Cancel'
        }

        const actionButtonProp = {
            textId: 'Confirm btn',
            defaultMessage: 'Leave without saving'
        }


        return <Fragment>
            {this._buildContentMenu()}
            {
                confirmationModal && <ConfirmationModal
                            isOpen={confirmationModal} 
                            messageTextProp={messageTextProp} 
                            title={confimationTitle}
                            actionButtonProp={actionButtonProp}
                            cancelButtonProp={cancelButtonProp}
                            actionFunc={confirmActionFunction}
                            cancelFunc={confirmCancelFunction}
                />
            }
            </Fragment>;
    }
}

// export const makeMapStateToProps = (state, ownProps) => {
//     const { teamsUnsavedFlag } = state.teams;

//     return {
//         teamsUnsavedFlag
//     }
// }

// const mapDispatchToProps = (dispatch) => ({
//    setUnsavedChanges: (params) => dispatch(setUnsavedChanges(params))
// })

export default withRouter(NavigationContentMenu);
